<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-change-number"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p v-html="title"></p>
                </div>
                <div class="modal-base-body">
                    <p v-html="message"></p>
                </div>
                <div class="row no-gutters pb-4 modal-base-input">
                    <div class="col-12 pr-2">
                        <ContactNumber
                            v-model="contactNumber"
                            inputId="change-contactNumber"
                            :inputLbl="lbl.myprofile.changeMobileNumber"
                            :isShowErrorLbl="true"
                            :isFirstSave="isFirstSave"
                            :textLeft="true"
                            :errorInfo="errorInfo[0]"
                        />
                    </div>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-cancel" @click="clickCancel()">{{btnCancel}}</button>

                    <button v-if="contactNumber.length < 10" class="btn btn-inactive ml-2">{{btnOk}}</button>
                    <button v-else class="btn btn-ok ml-2"  @click="clickOk()">{{btnOk}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import Util from "@/helper/Utility.js";
// component
import ContactNumber from '../../../Input/ContactNumber.vue'
// mixin
import LocaleMixin from "@/mixin/LocaleMixin";
// helper
import FormHelper from "@/helper/FormHelper";
/**
 * @property {ChangeNumberModalController} controller (required) /components/Modal/Controller/ChangeNumberModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ChangeNumberModal",
    mixins: [LocaleMixin],
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    components: {
        ContactNumber
    },
    data: function() {
        return {
            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            tag: '',
            busModal: null,
            lbl: Locale.getLbl(),
            isFirstSave: true,

            contactNumber: '',
            errorInfo: FormHelper.genErrorInfo(1)
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.controller.sendCallbackOk({
                tag: this.tag,
                contactNumber: this.contactNumber
            });
            this.isFirstSave = false;
            this.contactNumber = '';
            this.hide();
        },
        clickCancel: function() {
            this.contactNumber = '';
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            this.isFirstSave = true;
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import '@/style/base/base.scss';
    @import "@/style/modal.scss";
    .modal-change-number {
        @extend %modal-base;
        .modal-content {
            max-width: 430px;
            .modal-body {
                padding: 30px;
                .modal-base {
                    text-align: center;

                    .modal-base-head {
                        font-family: 'PRT-SemiBold';
                        color: $a-black-333333;
                        font-size: 18px;
                    }

                    .modal-base-body {
                        color: $a-black-333333;
                        padding: 4px 16px 0px;
                        p {
                            font-size: 16px;
                            margin: 0px;
                        }
                    }

                    .input-number {
                        padding-bottom: 64px;
                    }

                    .modal-base-input {
                        font-family: $ff-reg;
                    }

                    .modal-base-footer {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        justify-content: center;
                        .btn {
                            border-radius: 10px;
                            font-size: 16px;
                        }
                        .btn-ok {
                                font-family: $ff-reg;
                                color: white;
                                background: $main-orange-color;
                                padding: 8px 54px;
                            }
                            .btn-inactive {
                                font-family: $ff-reg;
                                color:$a-gray-999999;
                                background:#cdcdcd;
                                padding: 8px 54px;
                            }

                        .btn-cancel {
                            font-family: $ff-reg;
                            color: $main-orange-color;
                            background: white;
                            padding: 8px 54px;
                            border: 1px solid $main-orange-color;
                        }
                    }
                }
            }
        }
    }
</style>
